import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { Box, Typography } from '@mui/material'
import { useBinsService, useWheatCodesService } from 'services'
import {
  consistencyInfoList,
  DATA_ANALYSIS_INFO,
  TInfoValues,
} from '../utils/consts'
import ColoredList, { SHAPES } from 'components/ui/ColoredList/ColoredList'
import { assignWheatCodeColors } from '../utils/wheatCodeColors'
import * as sxStyles from './DataAnalysisFiltersInfo.styled'

interface IDataAnalysisInfoProps {
  infoList: DATA_ANALYSIS_INFO[]
}

const DataAnalysisInfo = ({ infoList }: IDataAnalysisInfoProps) => {
  const { getBins } = useBinsService()
  const { getWheatCodes } = useWheatCodesService()

  const { data: bins } = useQuery({
    queryKey: ['bins-list'],
    queryFn: () => getBins(),
  })

  const { data: wheatCodes } = useQuery({
    queryKey: ['wheat_codes_list'],
    queryFn: () => getWheatCodes(),
  })

  const binOptions: TInfoValues[] | [] =
    bins?.results?.map((bin) => ({
      id: Number(bin.id),
      name: bin.name,
      color: bin.color.hex_code,
    })) || []

  const wheatCodeColorMap = useMemo(() => {
    const items = (wheatCodes?.results || []).map((w: any) => ({
      id: Number(w.id),
      code: String(w.code),
    }))
    return assignWheatCodeColors(items)
  }, [wheatCodes])

  const wheatCodeOptions: TInfoValues[] = (wheatCodes?.results || []).map(
    (w: any) => ({
      id: Number(w.id),
      name: String(w.code),
      color: wheatCodeColorMap[w.id],
    })
  )

  return (
    <Box>
      {infoList.map((infoOption, index) => {
        switch (infoOption) {
          case DATA_ANALYSIS_INFO.CONSISTENCY:
            return (
              <Box key={`consistency-${index}`}>
                <br />
                <Typography sx={sxStyles.typographyStyle}>
                  Consistency
                </Typography>
                <ColoredList
                  valuesList={consistencyInfoList}
                  shape={SHAPES.CIRCLE}
                  title={''}
                />
              </Box>
            )
          case DATA_ANALYSIS_INFO.WHEAT_CODE:
            return (
              <Box key={`wheatCode-${index}`}>
                <br />
                <Typography sx={sxStyles.typographyStyle}>
                  wheat Codes
                </Typography>
                <ColoredList
                  valuesList={wheatCodeOptions}
                  shape={SHAPES.CIRCLE}
                  title={''}
                  maxHeight={'60vh'}
                />
              </Box>
            )
          case DATA_ANALYSIS_INFO.BIN:
            return (
              <Box key={`bin-${index}`}>
                <br />
                <Typography sx={sxStyles.typographyStyle}>Bins</Typography>
                <ColoredList
                  valuesList={binOptions}
                  shape={SHAPES.SQUARE}
                  title={''}
                />
              </Box>
            )
          case DATA_ANALYSIS_INFO.PRODUCT:
            return (
              <Box key={`bin-${index}`}>
                <Typography sx={sxStyles.typographyStyle}>Product</Typography>
              </Box>
            )
          default:
            return null
        }
      })}
    </Box>
  )
}

export default DataAnalysisInfo
